module.exports = __webpack_public_path__ + "985992266a9a8c66c3a7c1d1ef82141a.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1/public/history/fi-2004.png
// module id = 423
// module chunks = 0